import React from 'react';
import { usePagination } from '../../../../../../../../../../../utils/hooks';
import {
	RewardsTable,
	NoFilterData,
	NoRewardData,
} from '../../../../../../../../../../presentational';
import { useRewardsFilters } from '../FilterProvider';
import { flags } from '../../../../../../../../../../../utils';

/**
 * @description Responsible for pagination and displaying data
 */
export const Table = ({
	campaign,
	rewards,
	isLoading = true,
	error = undefined,
}) => {
	const { state, update, clear } = useRewardsFilters();
	const [getPagination] = usePagination({
		limit: state.limit || 10,
	});

	/**
	 * clear filters for NoFilteredData
	 */
	const clearControls = () => {
		clear('page', 'limit', 'skip');
	};
	/**
	 * @returns length of filters to be counted for NoData result
	 */
	const filterCount = () => {
		const skipFilters = ['page', 'limit', 'skip'];
		const queries = Object.keys({ ...state });
		const result = queries.filter((query) => !skipFilters.includes(query));
		return result.length;
	};

	const sortConfig = {
		sortServer: true,
		defaultSortField: 'updatedAt',
	};

	/**
	 * control pagination
	 */
	const paginationConfig = {
		paginationServer: true,
		paginationDefaultPage: state.page || 1,
		paginationTotalRows: rewards?.count,
		paginationPerPage: state.limit || 10,
		onChangePage: (next) => {
			const { skip, page } = getPagination({
				page: next,
			});
			update({
				skip,
				page,
			});
		},
		onChangeRowsPerPage: (currentRowsPerPage, page) => {
			const { skip, limit } = getPagination({
				page,
				limit: currentRowsPerPage,
			});
			update({
				skip,
				limit,
			});
		},
	};

	console.debug(rewards?.rows);

	return error ? (
		error?.message
	) : (
		<RewardsTable
			collection={rewards?.rows}
			campaign={campaign}
			progressPending={isLoading}
			noDataComponent={
				flags.isActive(flags.names.ENABLE_CUSTOM_NO_DATA_RESPONSE) ? (
					filterCount() > 0 ? (
						<NoFilterData resetFilter={clearControls} />
					) : (
						<NoRewardData />
					)
				) : (
					undefined
				)
			}
			{...paginationConfig}
			{...sortConfig}
		/>
	);
};
